import { render, staticRenderFns } from "./cmpt-item.vue?vue&type=template&id=4d3b53a7&"
import script from "./cmpt-item.vue?vue&type=script&lang=ts&"
export * from "./cmpt-item.vue?vue&type=script&lang=ts&"
import style0 from "./cmpt-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports